import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { apiError } from "@/lib/apiError";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";
import { Brand, LangToggle, inputClass, btnPrimary } from "@/components/Brand";

export default function ClientLogin() {
  const { clientLogin } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", access_code: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await clientLogin(form.email, form.access_code);
      navigate("/portal", { replace: true });
    } catch (err) {
      toast.error(apiError(err, "Invalid email or access code"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-[#F3F3F1] grain flex items-center justify-center px-5 py-16" data-testid="client-login-page">
      <div className="w-full max-w-sm fade-up">
        <div className="flex items-center justify-between mb-10">
          <Brand />
          <LangToggle />
        </div>
        <p className="eyebrow mb-4">{t("nav_client")}</p>
        <h1 className="text-4xl tracking-tighter font-medium mb-4">{t("client_login_title")}</h1>
        <p className="text-sm text-[#A8A8A8] mb-10">{t("client_login_hint")}</p>

        <form onSubmit={submit} className="space-y-6">
          <input data-testid="client-email-input" type="email" className={inputClass} placeholder={t("email")}
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          <input data-testid="client-code-input" className={`${inputClass} font-mono-accent tracking-[0.3em] uppercase`}
            placeholder={t("access_code")} value={form.access_code}
            onChange={(e) => setForm({ ...form, access_code: e.target.value })} required />
          <button data-testid="client-login-submit-btn" disabled={busy} className={`${btnPrimary} w-full py-4`}>
            {busy && <Loader2 size={14} className="animate-spin" />} {t("client_signin")}
          </button>
        </form>

        <Link to="/login" className="mt-8 block text-xs text-[#707070] hover:text-[#D4AF37]">
          {t("nav_login")} →
        </Link>
      </div>
    </div>
  );
}
